export const LOADING = 'LOADING'
export const ADD_PARAMS = 'ADD_PARAMS'
export const ADD_DATA = 'ADD_DATA'
export const SET_WHITELABEL = 'SET_WHITELABEL'